/**
 * Curated palette for pattern color tagging. 10 hand-picked, yarn-friendly
 * hues that read clearly both as a thin bar and as a small dot against the
 * app's card/base surfaces. May be re-aligned to existing CSS variables in
 * code review.
 */
export const PATTERN_PALETTE: readonly string[] = [
  '#A8C66C', // soft green
  '#E58A8A', // muted coral
  '#7BAAD9', // dusty blue
  '#E8B864', // butter
  '#B294D6', // lavender
  '#5FB39E', // teal
  '#E89BB9', // pink
  '#94A4B8', // slate
  '#D87C57', // terracotta
  '#7C8FB1', // periwinkle
];

/**
 * Stable hash → palette index. djb2 is sufficient: we just need a stable,
 * well-distributed function over arbitrary string ids.
 */
function djb2(s: string): number {
  let h = 5381;
  for (let i = 0; i < s.length; i++) {
    h = (h * 33) ^ s.charCodeAt(i);
  }
  // Force unsigned 32-bit
  return h >>> 0;
}

export function deriveColor(patternId: string): string {
  const idx = djb2(patternId) % PATTERN_PALETTE.length;
  return PATTERN_PALETTE[idx];
}

export function resolvePatternColor(pattern: { id: string; color?: string }): string {
  return pattern.color ?? deriveColor(pattern.id);
}
